module.exports = __webpack_public_path__ + "img/icon-2.84cfc18.png";